import { render, staticRenderFns } from "./NewOrderMain.vue?vue&type=template&id=6708486e&scoped=true"
import script from "./NewOrderMain.vue?vue&type=script&lang=js"
export * from "./NewOrderMain.vue?vue&type=script&lang=js"
import style0 from "./NewOrderMain.vue?vue&type=style&index=0&id=6708486e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6708486e",
  null
  
)

export default component.exports